import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import type { CardActionProps } from "./types";

export const CardAction = ({ className, testID, children }: CardActionProps) => (
  <Box
    className={cn("flex shrink-0 flex-row items-center justify-center", className)}
    {...platformProps({ testID, slot: "card-action" })}
  >
    {children}
  </Box>
);

CardAction.displayName = "Card.Action";
